query AvailableTripTravelers($first: Int, $after: Cursor) {
  availableTripTravelers(
    orderBy: [_SORT_NAME_ASC, PRIMARY_KEY_ASC]
    first: $first
    after: $after
  ) {
    nodes {
      id
      _fullName
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
